export default {
  SET_MODULES_VERSIONS: 'SET_MODULE_VERSIONS',
  SET_MODULE_INFO: 'SET_MODULE_INFO',
  SET_PUBLISHED_VERSIONS: 'SET_PUBLISHED_VERSIONS',
  CONCAT_VERSIONS: 'CONCAT_VERSIONS',
};
